import axios from 'axios';
import {Authentication} from "./authentication";
import {Content} from "./content";
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


Authentication.init()
Content.init()
